import type { ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "secondary" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** danger is red and reserved for irreversible actions: at most one per screen (UX-01 principle 9). */
  variant?: ButtonVariant;
}

const variantClass: Record<ButtonVariant, string> = {
  primary: "btn",
  secondary: "btn sec",
  danger: "btn danger",
};

export function Button({ variant = "primary", type = "button", className, ...rest }: ButtonProps) {
  const classes = className ? `${variantClass[variant]} ${className}` : variantClass[variant];
  return <button {...rest} type={type} className={classes} />;
}
